import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Box,
  Chip,
  CircularProgress,
  Grid2,
  IconButton,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router";
import { Pacote } from "../../types";
import { CTable } from "../data-display/c-table.component";
import { ModalDeletePacotes } from "./modal-delete-pacotes.component";
import { ModalFormPacotes } from "./modal-form-pacotes.component";
import { memoObserver } from "../../utils/memoObserver.utils";
import { ModalEditPacotes } from "./modal-edit-pacotes.component";

export interface TablePacotesProps {
  data: Pacote[];
  loading: boolean;
}

export const TablePacotes = memoObserver(
  ({ data, loading }: TablePacotesProps) => {
    return (
      <CTable
        title="Pacotes"
        addForm={() => <ModalFormPacotes />}
        loading={loading}
        rows={data || []}
        columns={[
          {
            field: "title",
            headerName: "Titulo",
            width: 300,
          },
          {
            field: "local",
            headerName: "Local",
            width: 200,
          },
          {
            field: "preco",
            headerName: "Preço",
            width: 120,
            renderCell(params) {
              return `R$ ${params.row.preco}`;
            },
          },
          {
            field: "tag",
            headerName: "Categoria",
            width: 120,
            renderCell(params) {
              return (
                <Chip label={params.row.tag} style={getStyle(params.row.tag)} />
              );
            },
          },
          {
            field: "actions",
            headerName: "Ações",
            type: "custom",
            width: 120,
            disableColumnMenu: true,
            sortable: false,
            renderCell(params) {
              return (
                <Grid2 container spacing={1}>
                  <Grid2>
                    <ModalEditPacotes id={params.row.id} />
                  </Grid2>
                  <Grid2>
                    <ModalDeletePacotes data={params.row} />
                  </Grid2>
                </Grid2>
              );
            },
          },
        ]}
      />
    );
  }
);

const getStyle = (tag: string) => {
  if (tag === "Pacote") {
    return {
      background: "#DF8925",
      color: "white",
    };
  }

  if (tag === "Caravana") {
    return {
      background: "#038EAD",
      color: "white",
    };
  }

  if (tag === "Excursão") {
    return {
      background: "#BF0268",
      color: "white",
    };
  }
};
